import { FC } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { useGetList, useTranslate } from 'react-admin'
import { ScheduleOut } from '../../types/apiRequests'
import { dateFormatter } from '../../utils/dateFormatter'
import ScheduleCancelButton from '../../components/buttons/ScheduleCancelButton'

interface Props { certificateId?: string }

const CertificateSchedules: FC<Props> = ({ certificateId }) => {
  const translate = useTranslate()

  const { data, isLoading, error } = useGetList<ScheduleOut>(
    'schedule',
    {
      filter: certificateId ? { certificateId: [certificateId] } : {},
      sort: { field: 'installationDatum', order: 'ASC' },
      pagination: { page: 1, perPage: 50 },
    },
    { enabled: !!certificateId }
  )

  if (!certificateId) return null

  return (
    <Grid item sm={12}>
      <Typography variant="subtitle1" sx={{ marginBottom: '10px' }}>
        <span>{translate('data.schedule')}</span>:<br/>
      </Typography>

      {!isLoading && !error && (!data || data.length === 0) && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {translate('resources.schedule.empty', { _: 'Geen geplande installaties.' })}
        </Typography>
      )}

      {data?.map((s) => (
        <Box
          key={s.id}
          sx={{
            borderRadius: '10px',
            p: '20px 10px',
            backgroundColor: '#f5f5f5',
            mb: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Typography variant="body1">
            {translate(`resources.schedule.status.${s.status}`, {
              date: dateFormatter(s.installationDatum),
            })}
          </Typography>

          <ScheduleCancelButton schedule={s} />
        </Box>
      ))}
    </Grid>
  )
}

export default CertificateSchedules
